import { useLocation } from 'react-router-dom';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: 'website' | 'article';
  canonicalPath?: string;
  schema?: Record<string, unknown>;
}

const SITE_NAME = '韩国漫画网';
const BASE_URL = 'http://bendionline.com/';
const DEFAULT_TITLE = '韩国免费漫画-韩漫大全-下拉式漫画全集在线阅读-韩国漫画网';
const DEFAULT_DESC = '在韩国漫画网免费阅读韩漫大全，享受下拉式漫画全集在线浏览，资源丰富，更新迅速，分类清晰，为您带来便捷阅读体验。';
const DEFAULT_KEYWORDS = '韩国免费漫画,韩漫大全,下拉式漫画全集在线阅读,韩国漫画网';
const DEFAULT_OG_IMAGE = 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20reading%20platform%20brand%20banner%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20clean%20modern%20design%2C%20soft%20gradient%20background%2C%20korean%20comics%20branding&width=1200&height=630&seq=og-default-01&orientation=landscape';

export default function SEO({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESC,
  keywords = DEFAULT_KEYWORDS,
  ogImage = DEFAULT_OG_IMAGE,
  ogType = 'website',
  canonicalPath = '/',
  schema,
}: SEOProps) {
  const location = useLocation();
  const canonical = `${BASE_URL}${canonicalPath || location.pathname}`;

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: BASE_URL,
    description: DEFAULT_DESC,
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: BASE_URL,
    description: DEFAULT_DESC,
    inLanguage: 'zh-CN',
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description: description,
    url: canonical,
    isPartOf: {
      '@type': 'WebSite',
      name: SITE_NAME,
      url: BASE_URL,
    },
    inLanguage: 'zh-CN',
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: BASE_URL,
      },
    ],
  };

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="zh_CN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(orgSchema),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(webSiteSchema),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(webPageSchema),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(breadcrumbSchema),
        }}
      />
      {schema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        />
      )}
    </>
  );
}